const scrollToEls = document.querySelectorAll('a[href^="/#"]');

if (scrollToEls.length > 0) {
  scrollToEls.forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const href = el.getAttribute('href');
      
      if (!href || !href.includes('#')) {
        return;
      }

      const id = href.split('#')[1];
      let targetEl = document.getElementById(id);

      if (!targetEl) {
        return;
      }

      try {
        // Get the header height to account for fixed header
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;
        
        // Calculate the target position with fallback
        const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = Math.max(0, targetPosition - headerHeight);

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      } catch (error) {
        // Fallback to simple scroll if smooth scroll fails
        window.scrollTo(0, targetEl.offsetTop);
      }
    });
  });
}